module.exports = __webpack_public_path__ + "img/callas.50cd7332.jpg";